<template>
  <div class="text-xs-center">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="300" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" fab dark flat>
          <v-icon>account_circle</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-tile avatar>
            <v-avatar color="grey" class="mr-3">
              <span class="white--text" v-if="currentUser">{{shortName}}</span>
            </v-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-if="currentUser">{{currentUser.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-tile @click="logout">
            <v-list-tile-content>
              <v-list-tile-title>Se déconnecter</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  mounted() {
    this.currentUser = this.$keycloak.tokenParsed;
  },
  methods: {
    logout: function () {
      this.$keycloak.logout();
    },
  },
  computed: {
    shortName: function () {
      return `${this.currentUser.given_name.substr(
        0,
        1
      )}${this.currentUser.family_name.substr(0, 1)}`;
    },
  },
  data: () => ({
    menu: false,
    currentUser: undefined,
  }),
};
</script>